import { safetyTips } from "@/mocks/homeContent";

export default function TrustSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-8 lg:px-12">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mb-3">
            Trust & Safety Guide
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            We provide informational guidance only. The Mulebuy Spreadsheet is a guide system, not a direct seller. Follow these principles for a safe sourcing experience.
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {safetyTips.map((tip) => (
            <div
              key={tip.risk}
              className="bg-background-100 rounded-lg p-4 md:p-5 flex flex-col sm:flex-row sm:items-start gap-3 md:gap-4"
            >
              <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-accent-100 shrink-0">
                <i className="ri-shield-check-line text-accent-600 text-lg"></i>
              </div>
              <div className="flex-1">
                <h4 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1">
                  {tip.risk}
                </h4>
                <p className="text-xs md:text-sm text-foreground-600 mb-1.5">{tip.description}</p>
                <p className="text-xs md:text-sm text-accent-700 font-medium">
                  <span className="font-semibold">Prevention:</span> {tip.prevention}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <p className="text-xs md:text-sm text-foreground-500 italic">
            Always verify sellers before purchasing. Use secure payment methods. Understand shipping and customs rules.
          </p>
        </div>
      </div>
    </section>
  );
}